import Lang from "../../userPreferences/staticWords";
import * as Yup from "yup";

export const formikValidation = (touched, errors, fieldName) => {
  return touched[fieldName] && errors[fieldName] ? errors[fieldName] : false;
};
export const validationSchema = () => {
  return {
    pageOne: {
      firstName: Yup.string()
        .max(15, Lang.max)
        .min(3, Lang.min)
        .required(Lang.require),
      lastName: Yup.string()
        .max(15, Lang.max)
        .min(3, Lang.min)
        .required(Lang.require),
      email: Yup.string().email(Lang.invalidEmail).required(Lang.require),
      country: Yup.string().required(Lang.require),
      nationality: Yup.string().required(Lang.require),
      title: Yup.string().required(Lang.require),
      gender: Yup.string().required(Lang.require),
      phoneOne: Yup.string().required(Lang.require),
      phoneTwo: Yup.string().required(Lang.require),
      town: Yup.string().required(Lang.require),
      address: Yup.string().required(Lang.require),
      photo: Yup.string().required(Lang.require),
      brithDay: Yup.date().required(Lang.require),
    },
    pageTwo: {
      professionalStatus: Yup.string().required(Lang.require),
      proessionalAreaOfResearch: Yup.array()
        .min(1, Lang.minArr)
        .required(Lang.require),
      preferances: Yup.array().min(1, Lang.minArr).required(Lang.require),
      education: Yup.string().required(Lang.require),
    },
    loginPage: {
      username: Yup.string().required(Lang.require), //.email(Lang.invalidEmail)
      password: Yup.string()
        .max(30, Lang.passMax)
        // .min(8, Lang.passMin)
        .required(Lang.require),
    },
    addUser: {
      firstName: Yup.string().min(2, Lang.min).required(Lang.require),
      lastName: Yup.string(),
      email: Yup.string().email(Lang.invalidEmail).required(Lang.require),
      nationality: Yup.string(),
      title: Yup.string(),
      gender: Yup.string(),
      brithDay: Yup.date().nullable(),
      professionalStatus: Yup.string(),
      password: Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          Lang.invalidPassword
        )
        .max(30, Lang.passMax)
        // .required(Lang.require)
        .nullable(),
      researchAreas: Yup.array().nullable(),
      IsMember: Yup.boolean(),
      isTaskAdmin: Yup.boolean(),
      IsAdmin: Yup.boolean(),
      IsSuperAdmin: Yup.boolean(),
      mobileNumber: Yup.string(),
      ParentId: Yup.string(),
      PersonInContactId: Yup.string(),
      Address: Yup.string(),
      OfficeNumber: Yup.string(),
      PhotoFile: Yup.string().nullable(),
      UserName: Yup.string().min(2, Lang.min).required(Lang.require),
      files: Yup.array(),
      file: Yup.string(),
    },
    addCommunity: {
      Name_A: Yup.string().required(Lang.require),
      Name_E: Yup.string().required(Lang.require),
      Description_A: Yup.string().required(Lang.require),
      Description_E: Yup.string(),
      CoverPhoto: Yup.string().nullable(),
      LogoFile: Yup.string().nullable(),
      Logo: Yup.string().nullable(),
      SortIndex: Yup.string(),
      Focus: Yup.boolean().required(Lang.require),
      ResearchAreas: Yup.array().nullable(),
      Active: Yup.boolean().required(Lang.require),
      // SectorId: Yup.string().required(Lang.require),
    },
    confirmMail: {
      email: Yup.string().required(Lang.require),
    },
    resetPassword: {
      email: Yup.string().required(Lang.require),
      password: Yup.string().required(Lang.require).max(30, Lang.passMax),
    },
    addLookup: {
      name_A: Yup.string().required(Lang.require),
      name_E: Yup.string().required(Lang.require),
      sortIndex: Yup.string().required(Lang.require),
      isDefault: Yup.string().required(Lang.require),
      focus: Yup.string().required(Lang.require),
      active: Yup.string().required(Lang.require),
      description_A: Yup.string(),
      description_E: Yup.string(),
      color: Yup.string(),
    },
  };
};

export const initialValues = (pageData) => {
  return {
    confirmMail: {
      email: "",
    },
    resetPassword: {
      email: "",
      password: "",
    },
    pageOne: {
      firstName: pageData?.firstName ?? "",
      lastName: pageData?.lastName ?? "",
      email: pageData?.email ?? "",
      phoneOne: pageData?.phoneOne ?? "",
      phoneTwo: pageData?.phoneTwo ?? "",
      address: pageData?.address ?? "",
      town: pageData?.town ?? "",
      country: pageData?.country ?? "",
      nationality: pageData?.nationality ?? "",
      title: pageData?.title ?? "",
      gender: pageData?.gender ?? "",
      photo: pageData?.photo ?? "",
      brithDay: pageData?.brithDay ?? "",
    },
    pageTwo: {
      professionalStatus: pageData?.professionalStatus ?? "",
      proessionalAreaOfResearch: pageData?.proessionalAreaOfResearch ?? "",
      preferances: pageData?.preferances ?? "",
      attachment: pageData?.attachment ?? [],
      education: pageData?.education ?? "",
      fileType: "",
      file: "",
    },
    loginPage: {
      username: "",
      password: "",
    },
    addUser: {
      firstName: pageData?.firstNameA ?? "",
      lastName: pageData?.lastNameA ?? "",
      UserName: pageData?.userName ?? "",
      email: pageData?.email ?? "",
      nationality: pageData?.nationalityId ?? "",
      title: pageData?.titleId ?? "",
      gender: pageData?.genderId ?? "",
      brithDay: pageData?.birthDate,
      professionalStatus: pageData?.professionalStatusId ?? "",
      password: null,
      researchAreas: [],
      mobileNumber: pageData?.mobileNumber ?? "",
      active: pageData?.active ?? true,
      activeMember: true,
      PhotoFile: pageData?.photo ?? null,
      ParentId: pageData?.parentId ?? "",
      PersonInContactId: pageData?.personInContactId ?? "",
      Address: pageData?.address ?? "",
      OfficeNumber: pageData?.officeNumber ?? "",

      IsMember: pageData?.isMember ?? true,
      IsAdmin: pageData?.isAdmin ?? false,
      IsSuperAdmin: pageData?.isSuperAdmin ?? false,
      IsTaskAdmin: pageData?.isTaskAdmin ?? false,
      files: [],
      file: "",
    },
    addCommunity: {
      Name_A: pageData?.name_A ?? "",
      Name_E: pageData?.name_E ?? "",
      Description_A: pageData?.description_A ?? "",
      Description_E: pageData?.description_E ?? "",
      Logo: pageData?.logo ?? null,
      CoverPhoto: pageData?.coverPhoto ?? null,
      LogoFile: pageData?.Logo ?? null,
      CoverPhotoFile: pageData?.CoverPhoto ?? null,
      ResearchAreas: pageData?.researchArea ?? [],
      SortIndex: pageData?.sortIndex ?? 0,
      Focus: pageData?.focus ?? false,
      Active: pageData?.active ?? true,
      // SectorId: pageData?.sectorId ?? "",
    },
    addLookup: {
      name_A: pageData?.name_A ?? "",
      name_E: pageData?.name_E ?? "",
      description_A: pageData?.description_A ?? "",
      description_E: pageData?.description_E ?? "",
      color: pageData?.color ?? "",
      sortIndex: pageData?.sortIndex ?? 0,
      isDefault: pageData?.isDefault ?? true,
      focus: pageData?.focus ?? true,
      active: pageData?.active ?? true,
    },
  };
};

export const formikSetup = (
  initialValues,
  sourceOfIntailData,
  validationSchema,
  pageName,
  submitFunction
) => {
  return {
    initialValues: {
      ...initialValues(sourceOfIntailData)[pageName],
    },
    validationSchema: Yup.object({ ...validationSchema(Yup)[pageName] }),
    onSubmit: submitFunction,
  };
};
